export const removeDuplicatesFromArray = <T>(arr: T[]): T[] => {
	const newArray = arr.filter((item, index) => arr.indexOf(item) === index);

	return newArray.sort((a, b) => {
		if (parseInt(a as string, 10) < parseInt(b as string, 10)) {
			return -1;
		}
		if (parseInt(a as string, 10) > parseInt(b as string, 10)) {
			return 1;
		}

		return 0;
	});
};

export const removeDuplicateObjectFromArray = <T>(array: T[], matchAttribute = "id"): T[] => {
	try {
		// eslint-disable-next-line @typescript-eslint/ban-ts-comment
		// @ts-ignore
		const ids = array.map((o) => o[matchAttribute]);

		// eslint-disable-next-line @typescript-eslint/ban-ts-comment
		// @ts-ignore
		return array.filter((item, index) => !ids.includes(item[matchAttribute], index + 1));
	} catch (e) {
		console.log(e);

		return array;
	}
};

export const removeDuplicateObjectFromArrayByKeepingTheFirstIndex = <T>(
	array: readonly T[],
	uniqueIdentifier: keyof T,
): T[] => {
	const seen = new Set();

	return array.filter((item) => {
		const identifier = item[uniqueIdentifier];

		return seen.has(identifier) ? false : seen.add(identifier);
	});
};
